export const GET_IMPORTED_FILE_DATA = "GET_IMPORTED_FILE_DATA";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_FILE_DATA = "START_LOADING_FILE_DATA";
export const STOP_LOADING_FILE_DATA = "STOP_LOADING_FILE_DATA";
export const ERROR_LOADING_FILE_DATA = "ERROR_LOADING_FILE_DATA";